import createStore from "astrid-helpers/src/createStore";

export const [getMuteSelf, setMuteSelf, useMuteSelf] = createStore(true);
